// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"578":"216067ee","703":"75986e63","787":"4073570a"}[chunkId] + ".chunk.js";
};